<template>
    <div class="avatar" :class="{'avatar-description': this.description}">
        <v-avatar :initials="initials"/>
        <div v-if="description" class="avatar-info" v-push="{name: 'profile'}">
            <p v-fs-block>{{fullName}}</p>
            <p class="avatar-info-muted-text" v-fs-block>{{memberSince}}</p>
        </div>
    </div>
</template>

<script>

    import vAvatar from '@/components/v-avatar';

    export default {
        components: {vAvatar},
        props: {
            description: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            fullName() {
                return `${this.$store.getters['user/fullName']}`;
            },
            initials() {
                return `${this.$store.getters['user/initials']}`;
            },
            memberSince() {
                return `${this.$store.getters['user/memberSince']}`;
            },
        },
    };
</script>
